import { useQuery } from "@tanstack/react-query";
import { s3AdapterApi } from "@shared/api";

export function useFileLink({ fileId }: { fileId?: string }) {
  return useQuery({
    queryFn: () =>
      s3AdapterApi
        .get<{ content: string }>(`files/${fileId}?type=URL`)
        .then((r) => r.data),
    queryKey: ["file", fileId, "url"],
    enabled: !!fileId,
  });
}
